import Antd from 'ant-design-vue'
import * as antIcons from '@ant-design/icons-vue'
import type { App } from 'vue'

// antd插件，注册$antIcons全局变量
export default {
  install: (app: App<Element>) => {
    app.use(Antd)

    app.config.globalProperties.$antIcons = antIcons

  }
}
